type AuthorAvatarSize = 'sm' | 'md' | 'responsive';

const sizeClasses: Record<AuthorAvatarSize, string> = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  responsive: 'h-6 w-6 sm:h-8 sm:w-8',
};

interface AuthorAvatarProps {
  size?: AuthorAvatarSize;
  className?: string;
}

export default function AuthorAvatar({ size = 'sm', className = '' }: AuthorAvatarProps) {
  return (
    <img
      src="/apple-touch-icon.png"
      alt=""
      width={32}
      height={32}
      aria-hidden
      className={`shrink-0 rounded-full border border-gray-200 bg-white object-cover ${sizeClasses[size]} ${className}`.trim()}
    />
  );
}
